<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main-fluid";
import ExpedienteLista from "@components/ExpedienteLista"

export default {
  page: {
    title: "Página inicial",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    Layout,    
    ExpedienteLista
  },    
  methods: {
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Novo`,
          props: {
            editable: true
          }
        }
      );
    }
  },
  data() {
    return {
      title: "Página inicial",
      items: [
        {
          text: "Página inicial",
          href: "/",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="card-box">      
      <ExpedienteLista />
    </div>
  </Layout>
</template>
